module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.objects), function(obj, index) {
    return _c('span', [(obj.to != null) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'top'
        }
      }
    }, [_vm._v(_vm._s(obj.label))]) : _vm._e(), (obj.to == null) ? _c('span', [_vm._v(_vm._s(obj.label))]) : _vm._e(), (index < _vm.objects.length - 1) ? _c('span', [_vm._v(">")]) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dcdd6c4a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/breadcrumb.vue
// module id = 109
// module chunks = 1